<!--
 * @Description: 主视图
-->
<template>
  <section class="app-main">
    <router-view v-slot="{Component, route}">
      <keep-alive :include="cachedViews">
        <component
          :is="Component"
          :key="route.fullPath"
        />
      </keep-alive>
    </router-view>
  </section>
</template>

<script lang="ts">
import { useStore } from '@/store'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const store = useStore()
    const cachedViews = computed(() => store.state.tagViews.cachedViews)
    return {
      cachedViews
    }
  }
})
</script>

<style
  lang="scss"
  scoped
>
.app-main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  min-height: 0;
}

:deep(.main-content) {
  min-height: 100%;
  height: auto;
}
</style>
